<template>
  <div>
    <div class="serviceMap">
      <div ref="positionMap" style="height: 740px;"></div>
      <!-- <amap
        :zoom="12"
        view-mode="3D"
        async=""
        :center="center"
      >
        <amap-marker
          ref="mark"
          v-for="(item,index) in markList"
          v-if="item.checked && item.label.content"
          :key="index"
          :position="item.position"
          icon="/static/images/marker.png"
          :label="item.label"
        ></amap-marker>
      </amap> -->
      <div class="position">
        <div class="positionCard">
          <div class="positionCardTitle el-row--flex is-align-middle">
            <span>定位查询（请使用空格或者换行隔开）</span>
          </div>
          <el-input type="textarea" :rows="3" v-model="plateNumber"></el-input>
          <el-select v-model="plateColor" placeholder="请选择车牌颜色" size="mini" style="width: 100%;margin-top: 10px;">
            <el-option label="蓝色" value="1"></el-option>
            <el-option label="黄色" value="2"></el-option>
            <el-option label="黄绿色" value="3"></el-option>
          </el-select>
          <el-input placeholder="车架号" v-model="vin"></el-input>
          <div class="positionCardBtn el-row--flex is-align-middle">
            <el-button size="small" type="primary" @click="position">定位</el-button>
            <el-button size="small" @click="plateNumber = ''">清除</el-button>
          </div>
        </div>
        <div class="positionCard">
          <div class="positionCardTitle el-row--flex is-justify-space-between is-align-middle">
            <span>定位记录</span>
            <el-button size="small" type="primary" @click="exportExcel">导出</el-button>
          </div>
          <div>
            <div class="positionCardTd el-row--flex is-align-middle" :class="{active: currentIndex == index}" v-for="(item, index) in markList" :key="index" @click="currentIndex = index">
              <div class="positionCardImg" @click.stop="checkChange(index)">
                <div v-if="currentIndex == index && item.checked">
                  <img src="/static/images/icon/icon-checkbox-active.png" >
                </div>
                <div v-else-if="item.checked">
                  <img src="/static/images/icon/icon-checkbox-checked.png" >
                </div>
                <div v-else>
                  <img src="/static/images/icon/icon-checkbox.png" >
                </div>
              </div>
              <div style="width: calc(100% - 30px);">
                <div>
                  <span class="positionCardNumber">{{item.plateNumber}}</span>
                  <span class="positionCardDate">{{item.data.utc}}</span>
                </div>
                <div class="positionCardAddress">{{item.data.adr}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AMapLoader from '@amap/amap-jsapi-loader';

  window._AMapSecurityConfig = {
	serviceHost: location.protocol + '//www.cywy56.com/_GuanWangMapService'
  };

  export default {
    data() {
      return {
        center: [110.268663, 30.202519],
        plateNumber: '',
        plateColor: '2',
        vin:'',
        currentIndex: -1,
        markList: [],
        map: null
      }
    },
    async mounted() {
      AMapLoader.load({
          'key': 'e5f3708364a5fc621433f7819929b056',
          'version': '2.0',
          'plugins': ['AMap.Geolocation', 'AMap.MoveAnimation', 'AMap.ToolBar']
      }).then((AMap) => {
        new AMap.Geolocation().getCurrentPosition((status, res) => {
          if (status == 'complete') {
            this.center = [res.position.lng, res.position.lat];
          }
        })
        // 渲染地图
        let option = {
          resizeEnable: true, // 监控地图容器尺寸变化
          zoom: 12,  // 初缩放级别
          center: this.center  // 初始中心点
        };
        if (this.mapStyle) {
          option.mapStyle = this.mapStyle;
        } else if (this.darkMode) {
          option.mapStyle = 'amap://styles/dark';
        }
        this.map = new AMap.Map(this.$refs.positionMap, option);
        this.map.addControl(new AMap.ToolBar())
      })
    },
    methods: {
      checkChange(ind) {
        if (this.markList[ind].checked !== undefined) this.markList[ind].checked = !this.markList[ind].checked;
        if (this.markList[ind].checked === false) this.markList[ind].marker.hide()
        else this.markList[ind].marker.show()
      },
      position() {
        let arr = this.plateNumber.split(/\s/g),
          flag = true;
        arr = arr.filter(n => n);
        if (arr != '') {
          arr.forEach(ele => {
            if (!/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Za-z]{1}[A-Za-z0-9]{4}[A-Za-z0-9]{1}|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Za-z]{1}[A-Za-z0-9]{4}[A-Za-z0-9]{2}$/g.test(ele)) {
              flag = false;
            }
          })
        } else {
          flag = false;
        }
        if (flag) {
          this.currentIndex = -1;
          this.$global.axios.post(this, '/sywl/api/locus/searchLastLocation', {
            plateNumber: arr.join(','),
            plateColor: this.plateColor,
                  vin: this.vin
          }, res1 => {
            this.$global.goPay(this, res1.data, res => {
              if (res.data.length != 0) {
                let arr1 = new Array();
                let resData = res.data.filter(ele => {
                  return JSON.stringify(ele.data) !== '{}'
                })
                resData.forEach(async (ele) => {
                  ele.checked = true;
                  ele.label = {
                    content: '最后定位时间：'+ele.data.utc+'<br>最后定位地点：'+ele.data.adr,
                    offset: new AMap.Pixel(0, -25),
                    direction: 'right'
                  };
                  arr1.push([ele.data.lon, ele.data.lat]);
                  ele.position = [ele.data.lon, ele.data.lat];
                })
                this.$global.convertMultiple({
                  AMap: AMap,
                  data: arr1,
                  handle: res1 => {
                    this.map.clearMap()
                    resData.forEach((ele, index) => {
                      ele.position = res1[index];
                      ele.marker = new AMap.Marker({
                        map: this.map,
                        position: ele.position,
                        icon: '/static/images/marker.png',
                        offset: new AMap.Pixel(-13, -17)
                      })
                      ele.marker.setLabel(ele.label)
                    })
                    this.markList = resData;
                    this.map.setFitView()
                  }
                })
              } else {
                this.$message.warning('暂无数据');
              }
            })
          })
        } else {
          this.$message.warning('车牌号格式有误');
        }
      },
      exportExcel() {
        if (this.markList.length == 0) {
          this.$message.warning('请先查询定位信息');
        } else {
          const columns = [
            { title: '车牌号', key: 'plateNumber' },
            { title: '定位时间', key: 'data.utc' },
            { title: '所在省份', key: 'data.province' },
            { title: '所在城市', key: 'data.city' },
            { title: '所在区县', key: 'data.country' },
            { title: '具体定位', key: 'data.adr' },
            { title: '经度', key: 'data.lon' },
            { title: '纬度', key: 'data.lat' }
          ];
          this.$global.export2Excel(columns, this.markList, '车辆定位数据');
        }
      }
    },
    watch: {
      currentIndex(n) {
        this.center = this.markList[n].position;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .serviceMap {
    position: relative;
    width: 100%;
    height: 740px;

    & /deep/ .amap-logo,
    & /deep/ .amap-copyright {
      display: none!important;
    }

    & /deep/ .amap-icon img {
      position: inherit;
    }

    & /deep/ .amap-marker-label {
      padding: 6px 15px;
      border: none;
      border-radius: 3px;
      background-color: rgba($color: #000000, $alpha: .7);
      line-height: 20px;
      color: #fff;
      text-align: left;
    }

    .position {
      position: absolute;
      top: 4px;
      right: 15px;

      &Card {
        margin-top: 20px;
        width: 280px;
        background-color: #fff;

        &Title {
          height: 37px;
          padding: 0 14px;
          background: rgba(238, 240, 242, .9);
          border-radius: 2px;
          font-size: 13px;
          color: #000;
        }

        &Btn {
          height: 54px;
          padding: 0 13px;
        }

        &Td {
          height: 48px;
          padding: 0 23px 0 15px;
          text-align: left;
          font-weight: 500;
          color: #333;
        }

        &Img {
          margin-right: 14px;
        }

        &Number {
          font-size: 13px;
        }

        &Date {
          margin-left: 11px;
          font-size: 12px;
        }

        &Address {
          font-size: 12px;
          font-weight: 400;
          color: #666;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        &Td.active {
          background-color: #1875f0;
          color: #fff;

          .positionCardAddress {
            color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/position.vue